// extracted by mini-css-extract-plugin
export var dividerLine = "_8l-3";
export var itemImage = "_8l-9";
export var lightDivider = "_8l-4";
export var modalContent = "_8l-5";
export var modalContentCompact = "_8l-6";
export var productCard = "_8l-a";
export var productImage = "_8l-b";
export var productImageCompact = "_8l-7";
export var productImagePlaceholder = "_8l-c";
export var productImagePlaceholderCompact = "_8l-8";
export var progressBarBackground = "_8l-1";
export var progressBarContainer = "_8l-0";
export var progressBarFill = "_8l-2";